if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        document.addEventListener("DOMContentLoaded", () => {
          this.form = this.querySelector("form");
          this.cartNotification = document.querySelector("cart-notification");
          this.addToCartButton = this.querySelector('[type="submit"]');
          this.variantSelector = this.querySelector("select, input[type='radio'], input[type='hidden'][name='id']");

          if (!this.form || !this.cartNotification || !this.addToCartButton || !this.variantSelector) {
            console.error("❌ Missing elements in product form.");
            return;
          }

          // Listen for variant changes
          this.variantSelector.addEventListener("change", this.handleVariantChange.bind(this));

          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        });
      }

      handleVariantChange() {
        setTimeout(() => {
          const selectedVariant = this.form.querySelector("[name='id']").value;
          if (selectedVariant) {
            this.addToCartButton.disabled = false;
          } else {
            this.addToCartButton.disabled = true;
          }
        }, 100); // Small delay to ensure variant updates
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.cartNotification) {
          console.error("❌ Cart notification component is missing.");
          return;
        }

        const submitButton = this.querySelector('[type="submit"]');
        if (!submitButton || submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.body = JSON.stringify({
          ...JSON.parse(serializeForm(this.form)),
          sections: this.cartNotification.getSectionsToRender()?.map((section) => section.id) || [],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            window.location.href = "/cart";
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
